import { Component, OnInit, inject } from '@angular/core';
import { CdsSize, CdsStyle } from '@cds/ng-core/configuration';
import { CDS_POPUP_DATA } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

interface CdWarningPopupButton {
  style: CdsStyle;
  size: CdsSize;
  text: string;
  cb: () => void;
}

@Component({
  selector: 'app-simple-popup',
  templateUrl: './simple-popup.component.html',
  styleUrls: ['./simple-popup.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class SimplePopupComponent implements OnInit {
  data = inject<{
    message: string;
    buttons: CdWarningPopupButton[];
  }>(CDS_POPUP_DATA);

  ngOnInit(): void {}
}
